var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M8.3536 9.79302C11.7984 9.79302 14.591 8.50414 14.591 6.91422C14.591 5.32431 11.7984 4.03543 8.3536 4.03543C4.90878 4.03543 2.11621 5.32431 2.11621 6.91422C2.11621 8.50414 4.90878 9.79302 8.3536 9.79302Z",
    stroke: "#8247E5",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M8.35352 9.79301V12.6718",
    stroke: "#8247E5",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_3",
    d: "M2.11621 6.91423V9.79302C2.11621 11.2324 4.51521 12.6718 8.3536 12.6718C12.192 12.6718 14.591 11.2324 14.591 9.79302V6.91423",
    stroke: "#8247E5",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_4",
    d: "M12.1919 9.19931V12.0781",
    stroke: "#8247E5",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_5",
    d: "M4.51514 9.19931V12.0781",
    stroke: "#8247E5",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipOut);
export default __webpack_public_path__ + "static/media/chip-out.fc414427ac7a9e7e4e6d6dc70ad8e126.svg";
export { ForwardRef as ReactComponent };